import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouteMatch } from "react-router";
import { useHistory } from "react-router-dom";
import AceEditor from "react-ace";
import { KTextInput } from "@kyburz/kdesign-system";

import useSetState from "../../hooks/useSafeSetState";
import BaseLayout from "../../components/layouts/BaseLayout";
import KFormBackground from "../../components/ui/KFormBackground";
import { editTemplate, getTemplate } from "../../apiCalls/config/templates";
import { setAlert } from "../../redux/actions/actions";

import { useStyles } from "./styles";

const TemplateView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history: any = useHistory();
  const match = useRouteMatch({
    path: "/config/templates/templates/:name",
    strict: true,
    sensitive: true,
  });
  const { name } = match?.params as any;

  const [{ description, template, errorMessage }, setState] = useSetState({
    description: "",
    template: "",
    errorMessage: null,
  });

  const handleChange = (e) => setState({ [e.target.name]: e.target.value });

  const handleTemplateChange = (newTemplate) => {
    let errorM = null;
    try {
      JSON.parse(newTemplate);
    } catch (e) {
      errorM = e.message;
    }
    setState({
      template: newTemplate,
      errorMessage: errorM,
    });
  };

  const handleSubmit = () => {
    if (errorMessage) {
      dispatch(setAlert("Template is not valid", "error"));
      return;
    }
    editTemplate(name, description, JSON.parse(template))
      .then(() => {
        dispatch(setAlert("Saved successfully", "success"));
      })
      .catch((e) => {
        dispatch(setAlert("An error occurred", "error"));
        console.error(e);
      });
  };

  useEffect(() => {
    getTemplate(name).then((res) => {
      setState({
        description: res.data.description,
        template:
          res.data.template === null
            ? ""
            : JSON.stringify(res.data.template, null, 2),
      });
    });
  }, [name]);

  return (
    <BaseLayout
      title={`Edit Template ${name}`}
      handleArrowClick={() => history.push("/config/templates/templates")}
    >
      <KFormBackground
        size="large"
        primaryCTAColor="primary"
        primaryCTAonClick={handleSubmit}
        primaryCTAText="Save"
        secondaryCTAText="Cancel"
        secondaryCTAonClick={() => history.goBack()}
        disabled={!!errorMessage}
      >
        <div>
          <KTextInput
            label="Name"
            name="name"
            value={name}
            onChange={handleChange}
            disabled={true}
            style={{ display: "inline-block", marginRight: "24px" }}
          />
          <KTextInput
            label="Description"
            name="description"
            value={description}
            onChange={handleChange}
            width="320px"
            style={{ display: "inline-block" }}
          />
        </div>

        <div className={classes.templateContainer}>
          <p className={classes.templateHeader}>Template</p>
          <AceEditor
            mode="json"
            width="752px"
            height="500px"
            theme="monokai"
            name={name}
            onChange={handleTemplateChange}
            fontSize={14}
            showPrintMargin={true}
            showGutter={true}
            highlightActiveLine={true}
            value={template}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              tabSize: 2,
            }}
            style={{ borderRadius: 4 }}
          />
          {errorMessage && (
            <p className={classes.templateError}>
              {`Validation error: ${errorMessage}`}
            </p>
          )}
        </div>
      </KFormBackground>
    </BaseLayout>
  );
};

export default TemplateView;
